// Foundations
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CamperCamsService } from 'src/app/services/camper-cams.service';

// Components
import { CampLocationSearchSelectComponent } from '../../_share/camp-location-search-select/camp-location-search-select.component';

@Component({
  selector: 'app-camper-cams-search-location',
  templateUrl: './camper-cams-search-location.component.html',
  styleUrls: ['./camper-cams-search-location.component.scss']
})
export class CamperCamsSearchLocationComponent implements OnInit {

  @Output() changeStep = new EventEmitter<number>();

  @ViewChild('searchSelect', { static: false }) searchSelect: CampLocationSearchSelectComponent;

  selectedCampId: number;
  isBtnEnabled = false;

  constructor(
    private ccService: CamperCamsService,
    private _analytics: AnalyticsService,
  ) { }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  onConfirmSelect(): void {
    this._analytics.logButtonTap('camperCams_confirmCamperLocation');
    this.ccService.newOptionFromSearch = this.searchSelect.currentSelection;
    this.changeStep.emit(1);
  }


  handleSelectedCampId(id: number): void {
    this.isBtnEnabled = !!id;
    this.selectedCampId = id;
  }

}
